import React from 'react';
import { Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core';
import AddCollectionsPopup from './AddCollectionsPopup';

const useStyles = makeStyles({
  categoryCardContainer: {
    height: '44px',
  },
  categoryCard: {
    width: '65px',
    height: '20px',
    padding: '4px 8px 4px 8px',
    gap: '10px',
    borderRadius: '4px 4px 0px 0px',
    opacity: '0px',
    background: '#622FEE',
    marginTop: '8px',
  },
  categoryText: {
    fontFamily: 'Lato',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '14px',
    textAlign: 'center',
    color: '#FEFEFE',
  },
  addCollectionText: {
    fontFamily: 'Lato',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '14px',
    textAlign: 'center',
    color: '#622FEE',
    textDecoration: 'underline',
    paddingBottom: '5px',
    cursor: 'pointer',
  },
});

const CategoryChipContainer = ({ ind, categoryId, deptName, deptId }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      className={classes.categoryCardContainer}
    >
      <Grid item>
        <Card className={classes.categoryCard}>
          <CardContent style={{ padding: 2 }}>
            <Typography className={classes.categoryText}>{`Category ${ind}`}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item>
        <Typography className={classes.addCollectionText} onClick={handleOpen}>
          + Add Collection
        </Typography>
        {open && (
          <AddCollectionsPopup
            handleClose={handleClose}
            isOpen={open}
            isEdit={false}
            categoryId={categoryId}
            deptName={deptName}
            deptId={deptId}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default CategoryChipContainer;
